import { Section } from "../State/Routine/types";
import { coerceString } from "./coerceString";

export function sectionsDirtyCheck(
  remoteSections: readonly {
    orgTopic: { id: string } | null;
    orgCanBeDisabled: boolean | null;
    section: Readonly<{
      id: string;
      title: string | null;
      assignedTeam: { id: string } | null;
    }>;
  }[],
  localSections: Section[] | undefined
) {
  if (localSections === undefined) {
    return false;
  }

  for (const localSection of localSections) {
    const remoteSection = remoteSections[localSection.ordinal];
    if (!remoteSection) {
      return true;
    }
    const remoteOrgTopicId = remoteSection.orgTopic?.id;
    const localOrgTopicId = localSection.orgTopic?.id;
    const remoteOrgCanBeDisabled = remoteSection.orgCanBeDisabled ?? false;
    const localOrgCanBeDisabled = localSection.orgCanBeDisabled ?? false;

    const orgDirty =
      remoteOrgTopicId !== localOrgTopicId ||
      remoteOrgCanBeDisabled !== localOrgCanBeDisabled;
    if (
      !remoteSection ||
      remoteSection.section.id !== localSection.id ||
      coerceString(remoteSection.section.title) !==
        coerceString(localSection.title) ||
      remoteSection.section.assignedTeam?.id !==
        localSection.assignedTeam?.id ||
      orgDirty
    ) {
      return true;
    }
  }
  return false;
}
